export enum LoginCode {
  AVAILABLE = '0',
  NOT_CORRECT = '-1',
  NOT_AVAILABLE = '-2',
  /** DREQ0040576 - Account sospeso temporaneamente (30 min) per eccessivi tentativi errati */
  SUSPENDED = '-3',
  /** DREQ0040576 - Account disabilitato definitivamente */
  DISABLED = '-4',
  CHANGE_PASSWORD = '20',
  EMAIL_NOT_CERTIFIED = '50',
  PHONE_NOT_CERTIFIED = '51',
  BOTH_NOT_CERTIFIED = '52',
  BOTH_CERTIFIED = '53',
}
